import { FirebaseApp, FirebaseOptions, initializeApp } from "firebase/app";
import {
  Auth,
  fetchSignInMethodsForEmail,
  getAuth,
  onAuthStateChanged,
  User as FirebaseUser,
} from "firebase/auth";
import { Firestore, getFirestore } from "firebase/firestore";
import { FirebaseStorage, getStorage } from "firebase/storage";
import { createCollections } from "./collections";

const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.GATSBY_FIREBASE_DATABASE_URL,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
  measurementId: process.env.GATSBY_FIREBASE_MEASUREMENT_ID,
};

let app: FirebaseApp;
let auth: Auth;
let db: Firestore;
let storage: FirebaseStorage;
let collections: ReturnType<typeof createCollections>;
let authStateResolved = false;
let authStatePromise: Promise<FirebaseUser | null> | null = null;

if (typeof window !== "undefined") {
  // @ts-expect-error
  app = app || initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  collections = createCollections(db);
}

const awaitAuthReady = () => {
  if (typeof window === "undefined" || !auth) return Promise.resolve(null);
  if (authStateResolved) return Promise.resolve(auth.currentUser);

  if (!authStatePromise) {
    authStatePromise = new Promise<FirebaseUser | null>((resolve) => {
      const unsubscribe = onAuthStateChanged(
        auth,
        (user) => {
          authStateResolved = true;
          authStatePromise = null;
          unsubscribe();
          resolve(user);
        },
        () => {
          authStateResolved = true;
          authStatePromise = null;
          unsubscribe();
          resolve(null);
        },
      );
    });
  }

  return authStatePromise;
};

export {
  awaitAuthReady,
  auth,
  collections,
  fetchSignInMethodsForEmail,
  onAuthStateChanged,
  storage,
};
